import React from 'react';
import './SparkleEffect.css';

const SparkleEffect = () => {
  return (
    <>
      <div className="sparkle"></div>
      <div className="sparkle"></div>
      <div className="sparkle"></div>
      <div className="sparkle"></div>
      <div className="sparkle"></div>
      <div className="sparkle"></div>
    </>
  );
};

export const SparkleButton = ({ className, onClick, children, href, target, rel, ...restProps }) => {
  // If href is provided, render as an anchor link
  if (href) {
    return (
      <a 
        className={`sparkle-button ${className || ''}`}
        href={href}
        onClick={onClick}
        target={target}
        rel={rel}
        {...restProps}
      >
        <SparkleEffect />
        {children}
      </a>
    );
  }
  
  // Otherwise render as a button
  return (
    <button 
      className={`sparkle-button ${className || ''}`} 
      onClick={onClick}
      {...restProps}
    >
      <SparkleEffect />
      {children}
    </button>
  );
};

export default SparkleEffect;
